module.exports = __webpack_public_path__ + "static/percent-0ff8c5bb557b762f39d2c9fce7a93077.webp";